import React, { useEffect, useState } from "react";
import { ArrowRight } from "./ArrowRight";
import { ArrowLeft } from "./ArrowLeft";
import "./monthpicker.css";
import { translate } from "../../utils/translations/translate";
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const curDate = new Date();
const curMonth = {
    firstDay: new Date(curDate.getFullYear(), curDate.getMonth(), 1),
    lastDay: new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0),
  }
const MonthPicker = ({onMonthChange}) => {
  const [date, setDate] = useState(curDate); 
  const [month, setMonth] = useState(curMonth);
  const [open, setOpen] = useState(false);
  const handleMonthChange = (next) => {
    const newDate = next
      ? new Date(date.getFullYear(), date.getMonth() + 1, 1)
      : new Date(date.getFullYear(), date.getMonth() - 1, 1);

    setDate(newDate);
    setMonth({
      firstDay: new Date(newDate.getFullYear(), newDate.getMonth(), 1),
      lastDay: new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0),
    });
  };

  const handleMonthSelection = (monthIndex) => {
    const newDate = new Date(date.getFullYear(), monthIndex, 1);
    setDate(newDate);
    setMonth({
      firstDay: new Date(newDate.getFullYear(), monthIndex, 1),
      lastDay: new Date(newDate.getFullYear(), monthIndex + 1, 0),
    });
    setOpen(false);
  };
  const handleYearChange = (increment) => {
    let newDate = new Date(date);
    newDate.setFullYear(newDate.getFullYear() + (increment ? 1 : -1));
    setDate(newDate);
  };
  const isCurrentMonthSelected = curMonth.firstDay.toDateString() === month.firstDay.toDateString();
  useEffect(()=>{
    onMonthChange && onMonthChange(month)
  },[month,onMonthChange])
  return (
    <div
      className="month-picker-container"
      onBlur={() => setOpen(false)}
      onClick={() => setOpen(true)}
      tabIndex={0}
    >
      <div className="selected-month-display">
        <div
          onClick={(e) => {
            e.stopPropagation();
            handleMonthChange(false);
          }}
          className="arrow-container"
        >
          {ArrowLeft} 
        </div>
        <div className="selected-month-indicator">
            <span className="selected-month-label">{`${months[month.firstDay.getMonth()]} ${month.firstDay.getFullYear()}`}</span>
            {isCurrentMonthSelected && <span>{translate('labels.currentMonth')}</span>}
        </div>
        <div
          onClick={(e) => {
            e.stopPropagation();
            handleMonthChange(true);
          }}
          className="arrow-container"
        >
          {ArrowRight} 
        </div>
      </div>
      {open && (
        <div className="month-picker-options">
          <div className="title-month">
            <div onClick={() => handleYearChange(false)} className="arrow-container">
              {ArrowLeft}
            </div>
            {`${date.getFullYear()}`}
            <div onClick={() => handleYearChange(true)} className="arrow-container">
              {ArrowRight}
            </div>
          </div>
          <div className="months-container">
            {months.map((monthName, index) => (
              <div
                key={index}
                className={`single-month ${index === date.getMonth() ? "selected-month" : ""}`}
                onClick={() => handleMonthSelection(index)}
              >
                {monthName}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export { MonthPicker} ;
